import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 16px 24px;
  position: relative;
  margin-top: 0px;
  margin-left: 1px;
  display: flex;
  justify-content: space-between;
`;

export const Heading = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 0;
  margin-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Extra = styled.div`
  margin: 4px 0;
  white-space: nowrap;
  float: right;
`